import { createApp } from 'vue'
import options from './SubNavigation.options'

const el = '.kb-component--sub-navigation'
const DOM = document.querySelector(el)

export default function (Store) {
    if (!DOM || DOM.hasAttribute('data-v-app')) return

    const generalLink = {
        href: DOM.querySelector(':scope > A')?.href,
        displayName: DOM.querySelector(':scope > A')?.innerText
    }

    const subLinks = Array.from(DOM.querySelectorAll(':scope > UL A')).map(
        (link) => {
            return {
                href: link?.href,
                displayName: link?.innerText,
                ariaCurrent: link?.ariaCurrent
            }
        }
    )

    Store.commit('main/set_sub_navigation_links', { generalLink, subLinks })
    const props = {
        userData: DOM.dataset.userData ? JSON.parse(DOM.dataset.userData) : null
    }
    const component = createApp(options, props).use(Store)

    const template = DOM.outerHTML
    options.template = template
    component.mount(el)
}
